(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nytc-contextual-upsells"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('nytc-contextual-upsells')) return;
    const root = window.Shopify?.routes?.root || '/';
    const pro = 'trans-masc-pro-pump';
    let mutationBusy = false;
    const jack = 'jack-the-2-in-1-stroker-packer';
    const vibe = 'og-bullet-vibrator-10-speed-rechargeable';
    // round 2: the add-on settings ride along in each element's [data-config]; read per element so a
    // late-added element (cart drawer re-render) still picks them up.
    let cfg = {addon:false, jackOff:0, vibeOff:0, vibeHandle:'', vibeVariant:'', vibeImage:'', jackTitle:'Add Jack', vibeTitle:'Add Jack + a vibe', vibeName:'the vibe'};
    let addonOn = false;
    let vibe2 = '';
    function readConfig(el) {
      try { const c = el.querySelector('[data-config]'); if (c) cfg = Object.assign(cfg, JSON.parse(c.textContent)); } catch (_) {}
      addonOn = !!(cfg.addon && cfg.jackOff > 0);
      vibe2 = cfg.vibeHandle || '';
    }
    const strap = 'stp-strap';
    const insert = 'stp-sam-erection-rod';
    const singleChoice = [vibe]; // one-tap offers: always the first (base) variant, no picker
    const pouch = 'packer-pouch-magnetic-closure';
    const bundle = 'trans-masc-pro-pump-jack-stroker-kit';
    const excluded = [43327021514819,43524666851395,43550424662083,43550424694851,43550424727619,43616714948675,43540435894339];
    let revision = 0;
    let timer;
    function money(cents) {
      return window.theme?.Currency?.formatMoney ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
    }
    function fill(text, map) {
      return Object.keys(map).reduce((s,k) => s.split('['+k+']').join(map[k]), text || '');
    }
    function sized(url, width) {
      if (!url) return '';
      url = String(url);
      if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
      return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
    }
    function variantImage(product, variant) {
      const src = variant && variant.featured_image && variant.featured_image.src;
      return src || product.featured_image;
    }
    function candidates(handles, cart, mode) {
      const owned = [...handles,...cart.items.map(i=>i.handle)];
      const cartHandles = cart.items.map(i=>i.handle);
      const has = h => handles.includes(h);
      const isPump = h => h.startsWith('trans-masc-') && (h.includes('pump') || h === 'trans-masc-2-0-kit');
      const hasPump = owned.some(isPump);
      const hasJack = owned.some(h => h === jack || (h.includes('pump') && h.includes('jack')));
      const trueHasPump = cartHandles.some(isPump);
      const trueHasJack = cartHandles.some(h => h === jack || (h.includes('pump') && h.includes('jack')));
      const trueHasBundle = cartHandles.includes(bundle);
      const hasVibe = owned.some(h => /bullet|vibe|vibrator/.test(h) || h === 'joque-harness');
      const subtotal = cart.items.reduce((sum,i) => sum + (excluded.includes(i.variant_id) ? 0 : (i.line_price || 0)),0);
      const giftEligible = subtotal >= 20000;
      const out = [];
      const ladder = addonOn && ((mode === 'product' && handles[0] === pro) || (mode === 'cart' && (cartHandles.includes(pro) || trueHasBundle)));
      if (ladder) {
        if (mode === 'product') return ['__addon_jack', '__addon_vibe'];
        const hasVibe2 = owned.some(h => h === vibe2);
        if (!trueHasJack) out.push('__addon_jack');
        if (!hasVibe2 && !hasVibe) out.push('__addon_vibe');
        return out;
      }
      if (handles.some(h => isPump(h) || h === jack)) {
        if (!trueHasBundle) {
          if (trueHasJack && !trueHasPump) out.push(pro);
          else if (mode === 'product' && handles.some(isPump) && !hasJack) out.push(jack);
          else out.push(bundle);
        }
        if (!hasVibe && !giftEligible) out.push(vibe);
      }
      if (handles.some(h => /shilo|carter/.test(h)) && !hasVibe && !giftEligible) out.push(vibe);
      if (has('sam-the-stp') && !owned.includes('sam-stp-complete-kit')) out.push(insert,strap);
      if (has('archer-gender-affirming-packer')) out.push(strap);
      if (has('pierre')) out.push(pouch,strap);
      return [...new Set(out)].filter(h => !owned.includes(h));
    }
    async function sync() {
      const request = ++revision;
      try {
        const response = await fetch(root + 'cart.js', {cache:'no-store',credentials:'same-origin'});
        if (!response.ok) return;
        const cart = await response.json();
        if (request !== revision) return;
        document.querySelectorAll('nytc-contextual-upsells').forEach(el => el.render(cart));
        const shipping = document.querySelector('[data-cart-free-shipping]');
        if (shipping) {
          const threshold = Number(shipping.dataset.threshold) * 100;
          if (threshold > 0) {
            const left = Math.max(0,threshold - cart.total_price);
            const message = shipping.querySelector('.cart-drawer__free-shipping-message');
            message.textContent = left ? shipping.dataset.progressMessage.replace('[amount]',money(left)) : shipping.dataset.qualifiedMessage;
            message.classList.toggle('cart-drawer__free-shipping-message--qualified',!left);
            shipping.querySelector('.cart-drawer__progress-bar').style.width = Math.min(100,cart.total_price / threshold * 100) + '%';
          }
        }
      } catch (_) {}
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(sync,150); }
    function track(target, name, detail) {
      target.dispatchEvent(new CustomEvent(name,{detail:Object.assign({source:'bundle',merchandise:true},detail||{}),bubbles:true}));
    }
    class ContextualUpsells extends HTMLElement {
      connectedCallback() {
        readConfig(this);
        const stock = JSON.parse(this.querySelector('[data-stock]').textContent);
        this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent).filter(p => p && p.available).map(p=>({...p,variants:p.variants.filter(v=>stock.includes(v.id))})).filter(p=>p.variants.length);
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        try { this.swatches = JSON.parse(this.querySelector('[data-swatches]').textContent); } catch (_) { this.swatches = {}; }
        schedule();
      }
      // Tappable shade chips. Pre-selects the first variant when every variant is a known shade
      // (Cashew/Caramel/Hazelnut); for anything else (sizes) nothing is selected until the shopper taps.
      picker(product, variants, onChange, initialVariantId = null) {
        const swatches = this.swatches || {};
        const key = v => String(v.title || '').trim().toLowerCase();
        const allShades = variants.every(v => swatches[key(v)]);
        let current = variants.find(v => Number(v.id) === Number(initialVariantId)) || (allShades ? variants[0] : null);
        const wrap = document.createElement('div'); wrap.className = 'nytc-offer__shades'; wrap.setAttribute('role','radiogroup'); wrap.setAttribute('aria-label', this.copy.choose + ' ' + product.title);
        const chips = variants.map(v => {
          const chip = document.createElement('button'); chip.type = 'button'; chip.className = 'nytc-shade'; chip.setAttribute('role','radio'); chip.dataset.variant = String(v.id);
          if (swatches[key(v)]) { const dot = document.createElement('span'); dot.className = 'nytc-shade__dot'; dot.style.backgroundImage = 'url("' + swatches[key(v)] + '")'; chip.append(dot); }
          const name = document.createElement('span'); name.className = 'nytc-shade__name'; name.textContent = v.title; chip.append(name);
          chip.addEventListener('click', () => { current = v; paint(); onChange(v); });
          return chip;
        });
        const paint = () => chips.forEach((c,i) => { const on = variants[i] === current; c.classList.toggle('is-selected', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); c.tabIndex = on || (!current && i === 0) ? 0 : -1; });
        wrap.addEventListener('keydown', event => {
          const index = chips.indexOf(event.target);
          if (index < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(wrap).direction === 'rtl';
          const back = event.key === 'ArrowUp' || (event.key === 'ArrowLeft' && !rtl) || (event.key === 'ArrowRight' && rtl);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? chips.length - 1 : (index + (back ? -1 : 1) + chips.length) % chips.length;
          chips[next].click();
          chips[next].focus();
        });
        paint();
        chips.forEach(c => wrap.append(c));
        return { el: wrap, get current() { return current; } };
      }
      // Dropdown for big variant sets (sizes x packs, e.g. the STP strap's 18 variants): nothing selected until the shopper picks.
      dropdown(product, variants, onChange) {
        let current = null;
        const select = document.createElement('select'); select.setAttribute('aria-label', this.copy.choose + ' ' + product.title);
        const placeholder = new Option(this.copy.choose, ''); placeholder.disabled = true; placeholder.selected = true; select.add(placeholder);
        variants.forEach(v => select.add(new Option(v.title, String(v.id))));
        select.addEventListener('change', () => { current = variants.find(v => String(v.id) === select.value) || null; if (current) onChange(current); });
        return { el: select, inline: true, get current() { return current; } };
      }
      async addToCart(button, idleLabel, variantId, {upgrade=false, successText, onAdded} = {}) {
        if (mutationBusy) return;
        mutationBusy = true;
        this.busy = true; button.disabled = true; button.textContent = this.copy.adding;
        const feedback = this.querySelector('[data-feedback]'); feedback.textContent = '';
        track(button,'nytc:cart-attempt',{variantIds:[Number(variantId)]});
        try {
          let replacement = null;
          if (upgrade) {
            const freshResponse = await fetch(root + 'cart.js', {credentials:'same-origin'});
            if (!freshResponse.ok) throw new Error(this.copy.error);
            const freshCart = await freshResponse.json();
            replacement = freshCart.items.find(i => i.handle === pro);
          }
          const response = await fetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.copy.error);
          if (replacement) {
            const removeResponse = await fetch(root + 'cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:replacement.key,quantity:Math.max(0,replacement.quantity-1)})});
            if (!removeResponse.ok) {
              const addedLine = result.items && result.items[0];
              if (addedLine) {
                const rollback = await fetch(root + 'cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:addedLine.key,quantity:Math.max(0,addedLine.quantity-1)})});
                if (!rollback.ok) throw new Error(this.copy.changed);
              }
              throw new Error(this.copy.error);
            }
          }
          feedback.textContent = successText || (upgrade ? this.copy.replaced : this.copy.added);
          this.sticky = variantId;
          if (onAdded) onAdded(variantId);
          track(button,'nytc:cart-confirmed',{variantIds:[Number(variantId)],verification:'add_response'});
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) { feedback.textContent = error.message || this.copy.error; track(button,'nytc:cart-failed',{variantIds:[Number(variantId)],outcome:'failed'}); }
        finally { mutationBusy = false; this.busy = false; button.disabled = false; button.textContent = idleLabel(); document.dispatchEvent(new CustomEvent('cart:build')); schedule(); }
      }
      // Sep 13 round 2: the Pro Pump add-on ladder (Jack, then Jack + the vibe).
      renderLadder(cart, wanted) {
        const isProductPage = this.dataset.mode === 'product';
        const proProduct = this.catalog.find(p => p.handle === pro);
        const jackProduct = this.catalog.find(p => p.handle === jack);
        const kitProduct = this.catalog.find(p => p.handle === bundle);
        const vibeProduct = this.catalog.find(p => p.handle === vibe2);
        const vibeVariant = vibeProduct ? (vibeProduct.variants.find(v => String(v.title || '').trim().toLowerCase() === String(cfg.vibeVariant || '').trim().toLowerCase()) || vibeProduct.variants[0]) : null;
        const vibeLine = vibeVariant && cart.items.find(i => Number(i.variant_id) === Number(vibeVariant.id));
        const cartHandles = cart.items.map(i => i.handle);
        const kitLine = cart.items.find(i => i.handle === bundle);
        const pumpInCart = cartHandles.includes(pro) || !!kitLine;
        const jackLine = cart.items.find(i => i.handle === jack);
        const showJack = wanted.includes('__addon_jack') && jackProduct && proProduct && kitProduct;
        const showVibe = wanted.includes('__addon_vibe') && vibeProduct && vibeVariant && proProduct && kitProduct && (jackProduct || jackLine);
        const signature = JSON.stringify(['ladder', showJack, showVibe, cart.items.filter(i => [pro, jack, bundle, vibe2].includes(i.handle)).map(i => [i.variant_id, i.quantity]), cfg.jackOff, cfg.vibeOff]);
        this.hidden = !(showJack || showVibe);
        if (this.hidden) { this.signature = signature; return; }
        if (signature === this.signature) return;
        this.signature = signature;
        const offers = this.querySelector('[data-offers]');
        offers.replaceChildren();
        this.querySelector('[data-included]').hidden = true;
        const proPrice = proProduct.variants[0].price;
        const jackVariants = jackProduct ? jackProduct.variants.filter(v => v.available && kitProduct.variants.some(k => k.available && k.title.trim().toLowerCase() === v.title.trim().toLowerCase())) : [];
        const cartShade = kitLine ? jackVariants.find(v => v.title.trim().toLowerCase() === String(kitLine.variant_title).trim().toLowerCase()) : null;
        const added = new Set();
        const viewCart = () => { const l = document.querySelector('.js-drawer-open-cart'); if (l) setTimeout(() => l.click(), 0); else location.href = root + 'cart'; };
        const card = document.createElement('div'); card.className = 'nytc-addon';
        let pick = null;
        const jackPrice = () => pick && pick.current ? pick.current.price : (jackLine ? jackLine.price : (cartShade ? cartShade.price : (jackVariants[0] ? jackVariants[0].price : 0)));
        const jackId = () => pick && pick.current ? pick.current.id : (jackLine ? jackLine.variant_id : (cartShade ? cartShade.id : (jackVariants[0] ? jackVariants[0].id : null)));
        const chosenKit = () => {
          const shade = jackVariants.find(v => Number(v.id) === Number(jackId()));
          return kitProduct.variants.find(k => k.available && shade && k.title.trim().toLowerCase() === shade.title.trim().toLowerCase()) || (kitLine && kitProduct.variants.find(k => Number(k.id) === Number(kitLine.variant_id)));
        };
        let pumpNow = pumpInCart;
        const totals = () => {
          const selectedKit = chosenKit();
          const t1 = selectedKit ? selectedKit.price : proPrice + jackPrice() - cfg.jackOff;
          const s1 = proPrice + jackPrice();
          const vp = vibeVariant ? vibeVariant.price : 0;
          return {t1, s1, t2: t1 + vp - cfg.vibeOff, s2: s1 + vp, save1: s1 - t1, save2: s1 - t1 + cfg.vibeOff, extra: vp - cfg.vibeOff};
        };
        const rows = [];
        const makeRow = (kind) => {
          const row = document.createElement('div'); row.className = 'nytc-addon__row';
          const image = document.createElement('img'); image.alt = ''; image.loading = 'lazy'; image.width = 84; image.height = 100;
          // owner (Sep 13): the Jack + vibe row shows BOTH pictures (Jack, then the vibe box) so it is clear two items are added
          let pictures = image, jackPic = null, plus = null;
          if (kind === 'jack') image.src = sized(variantImage(jackProduct, jackVariants[0]), 240);
          else {
            image.src = cfg.vibeImage || sized(vibeProduct.featured_image, 240); image.addEventListener('error', () => { image.src = sized(vibeProduct.featured_image, 240); }, {once:true});
            const jackSrc = jackProduct ? sized(variantImage(jackProduct, jackVariants[0]), 240) : (jackLine && jackLine.image ? sized(jackLine.image, 240) : '');
            if (jackSrc) {
              pictures = document.createElement('div'); pictures.className = 'nytc-addon__imgs';
              jackPic = document.createElement('img'); jackPic.alt = ''; jackPic.loading = 'lazy'; jackPic.width = 84; jackPic.height = 100; jackPic.src = jackSrc;
              plus = document.createElement('span'); plus.className = 'nytc-addon__plus'; plus.textContent = '+'; plus.setAttribute('aria-hidden', 'true');
              pictures.append(jackPic, plus, image);
            }
          }
          const body = document.createElement('div'); body.className = 'nytc-addon__body';
          const title = document.createElement('p'); title.className = 'nytc-addon__title';
          const link = document.createElement('a'); link.href = root + 'products/' + (kind === 'jack' ? jack : vibe2); link.textContent = kind === 'jack' ? cfg.jackTitle : cfg.vibeTitle; title.append(link);
          const total = document.createElement('p'); total.className = 'nytc-addon__total';
          // owner (Sep 13): "highlight the savings" - the saving is its own line right under the total: big yellow pill + the separate price
          const saveline = document.createElement('p'); saveline.className = 'nytc-addon__saveline';
          const save = document.createElement('span'); save.className = 'nytc-badge nytc-badge--save nytc-addon__save'; saveline.append(save);
          const sep = document.createElement('span'); sep.className = 'nytc-addon__sep'; saveline.append(sep);
          body.append(title, total, saveline);
          if (kind === 'jack' && (jackProduct.tags || []).some(t => /^top selling$/i.test(t))) { const pills = document.createElement('div'); pills.className = 'nytc-addon__pills'; const b = document.createElement('span'); b.className = 'nytc-badge nytc-badge--best'; b.textContent = this.copy.best_seller; pills.append(b); body.append(pills); }
          const full = document.createElement('div'); full.className = 'nytc-addon__full';
          const actions = document.createElement('div'); actions.className = 'nytc-offer__actions';
          const button = document.createElement('button'); button.type = 'button'; button.className = 'btn' + (kind === 'vibe' && showJack ? ' btn--secondary' : '');
          actions.append(button);
          const note = document.createElement('p'); note.className = 'nytc-addon__note';
          full.append(actions);
          if (!pumpInCart) { note.textContent = this.copy.addon_pump_note; full.append(note); }
          row.append(pictures, body, full);
          const r = {kind, row, total, sep, save, button, full, jackPic, plus, image};
          rows.push(r);
          return r;
        };
        const inCart = r => {
          const kit = chosenKit();
          const hasSelectedKit = added.has(jackId()) || (kit && cart.items.some(i => Number(i.variant_id) === Number(kit.id)));
          return !!hasSelectedKit && (r.kind === 'jack' || !!vibeLine || added.has(vibeVariant.id));
        };
        const paint = () => {
          const t = totals();
          const shade = jackVariants.find(v => Number(v.id) === Number(jackId()));
          const selectedKit = chosenKit();
          rows.forEach(r => {
            if (shade && r.kind === 'jack') r.image.src = sized(variantImage(jackProduct, shade), 240);
            if (shade && r.jackPic) r.jackPic.src = sized(variantImage(jackProduct, shade), 240);
            if (r.kind === 'jack') {
              r.total.replaceChildren(); const b = document.createElement('b'); b.textContent = money(t.t1); const parts = this.copy.addon_total.split('[total]'); r.total.append(parts[0] || '', b, parts[1] || '');
              r.sep.textContent = fill(this.copy.addon_separate, {separate: money(t.s1)});
              r.save.textContent = fill(this.copy.addon_save, {saving: money(t.save1)});
              r.button.textContent = inCart(r) ? this.copy.addon_in_cart : fill(this.copy.addon_btn, {total: money(t.t1)});
            } else {
              r.total.replaceChildren(); const b = document.createElement('b'); b.textContent = money(t.t2); const parts = fill(this.copy.addon_total_vibe, {vibe: cfg.vibeName}).split('[total]'); r.total.append(parts[0] || '', b, parts[1] || '');
              r.sep.textContent = fill(this.copy.addon_separate, {separate: money(t.s2)}) + ' ' + fill(this.copy.addon_vibe_extra, {extra: money(t.extra)});
              r.save.textContent = fill(this.copy.addon_save, {saving: money(t.save2)});
              const jackDone = added.has(jackId()) ||
                (jackLine && Number(jackLine.variant_id) === Number(jackId())) ||
                (selectedKit && cart.items.some(i => Number(i.variant_id) === Number(selectedKit.id)));
              r.button.textContent = inCart(r) ? this.copy.addon_in_cart : fill(jackDone ? this.copy.addon_btn_vibe_only : this.copy.addon_btn_vibe, {total: money(t.t2)});
              if (r.jackPic) { r.jackPic.hidden = !isProductPage && jackDone; r.plus.hidden = !isProductPage && jackDone; }
            }
            r.button.classList.toggle('is-added', inCart(r));
            r.button.disabled = !!(pick && !pick.current);
            const note = r.full.querySelector('.nytc-addon__note'); if (note) note.hidden = pumpNow;
          });
        };
        // Keep both product-page options and their shared shade selection visible after cart changes.
        if (showJack && jackVariants.length > 1) {
          const swatches = this.swatches || {};
          const allShades = jackVariants.every(v => swatches[String(v.title || '').trim().toLowerCase()]);
          const preferredShade = this.addonShadeVariantId || (cartShade && cartShade.id) || (jackLine && jackLine.variant_id);
          const updateShade = variant => { this.addonShadeVariantId = variant.id; paint(); };
          pick = allShades ? this.picker(jackProduct, jackVariants, updateShade, preferredShade) : this.dropdown(jackProduct, jackVariants, updateShade);
          const shadeWrap = document.createElement('div'); shadeWrap.className = 'nytc-addon__full nytc-addon__selector';
          const lbl = document.createElement('span'); lbl.className = 'nytc-offer__shades-label'; lbl.textContent = this.copy.shade + ' · Jack';
          shadeWrap.append(lbl, pick.el);
          card.append(shadeWrap);
        }
        if (showJack) card.append(makeRow('jack').row);
        if (showVibe) card.append(makeRow('vibe').row);
        rows.forEach(r => {
          r.button.addEventListener('click', () => {
            if (inCart(r)) { viewCart(); return; }
            const kit = chosenKit();
            if (!kit) return;
            this.addBundleOffer(r.button, {kitId: kit.id, jackId: jackId(), vibeId: r.kind === 'vibe' ? vibeVariant.id : null}, added, paint, () => { pumpNow = true; });
          });
        });
        paint();
        offers.append(card);
      }
      async addBundleOffer(button, offer, added, repaint, onPump) {
        if (mutationBusy) return;
        mutationBusy = true; this.busy = true; button.disabled = true;
        const idle = button.textContent; button.textContent = this.copy.adding;
        const feedback = this.querySelector('[data-feedback]'); feedback.textContent = '';
        const intendedIds = [Number(offer.kitId)].concat(offer.vibeId ? [Number(offer.vibeId)] : []);
        track(button,'nytc:cart-attempt',{variantIds:intendedIds});
        const post = async (path, data) => {
          const response = await fetch(root + path, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.copy.error);
          return result;
        };
        const readCart = async () => {
          const response = await fetch(root + 'cart.js', {cache:'no-store',credentials:'same-origin'});
          if (!response.ok) throw new Error(this.copy.error);
          return response.json();
        };
        const readCartRetry = async () => {
          let last;
          for (let attempt = 0; attempt < 2; attempt++) {
            try { return await readCart(); }
            catch (error) { last = error; }
          }
          throw last || new Error(this.copy.error);
        };
        const propertiesOf = line => JSON.stringify(Object.entries(line.properties || {}).sort(([a], [b]) => a.localeCompare(b)));
        const sameItem = (a, b) => Number(a.variant_id) === Number(b.variant_id) && propertiesOf(a) === propertiesOf(b) &&
          (a.selling_plan_allocation?.selling_plan?.id || null) === (b.selling_plan_allocation?.selling_plan?.id || null);
        const removeOne = async line => {
          const current = await readCart();
          const match = current.items.find(i => i.key === line.key) || current.items.find(i => sameItem(i, line));
          if (!match) throw new Error(this.copy.changed);
          await post('cart/change.js', {id:match.key,quantity:Math.max(0,match.quantity-1)});
        };
        const removed = []; let created = []; let additionConfirmed = false; let stage = 'before';
        try {
          const before = await readCartRetry();
          const hasKit = before.items.some(i => Number(i.variant_id) === Number(offer.kitId));
          const hasVibe = offer.vibeId && before.items.some(i => Number(i.variant_id) === Number(offer.vibeId));
          const items = [];
          if (!hasKit) items.push({id:offer.kitId,quantity:1});
          if (offer.vibeId && !hasVibe) items.push({id:offer.vibeId,quantity:1});
          stage = 'adding';
          if (items.length) {
            try {
              created = (await post('cart/add.js', {items})).items || [];
              additionConfirmed = true;
            } catch (addError) {
              const reconciled = await readCartRetry();
              const present = items.every(item => reconciled.items.some(i => Number(i.variant_id) === Number(item.id)));
              if (!present) throw addError;
              created = reconciled.items.filter(i => items.some(item => Number(item.id) === Number(i.variant_id)));
              additionConfirmed = true;
            }
          } else additionConfirmed = true;
          stage = 'replacing';
          if (!hasKit) {
            const replacements = [before.items.find(i => i.handle === pro), before.items.find(i => Number(i.variant_id) === Number(offer.jackId))].filter(Boolean);
            for (const line of replacements) {
              await removeOne(line);
              removed.push(line);
            }
          }
          stage = 'verifying';
          let fresh = null;
          try { fresh = await readCartRetry(); }
          catch (_) {
            feedback.textContent = 'Added, but the cart could not refresh. View your cart before trying again.';
            added.add(offer.jackId);
            if (offer.vibeId) added.add(offer.vibeId);
            this.sticky = offer.vibeId || offer.kitId;
            if (onPump) onPump();
            track(button,'nytc:cart-confirmed',{variantIds:intendedIds,verification:'add_response'});
            document.dispatchEvent(new CustomEvent('cart:updated'));
            return;
          }
          stage = 'reconciling';
          const kit = fresh.items.find(i => Number(i.variant_id) === Number(offer.kitId));
          const extra = offer.vibeId ? fresh.items.find(i => Number(i.variant_id) === Number(offer.vibeId)) : null;
          if (!kit || (offer.vibeId && !extra)) throw new Error(this.copy.changed);
          const total = kit.final_price + (extra ? extra.final_price : 0);
          feedback.textContent = fill(this.copy.addon_added, {total:money(total)});
          added.add(offer.jackId);
          if (offer.vibeId) added.add(offer.vibeId);
          this.sticky = offer.vibeId || offer.kitId;
          if (onPump) onPump();
          track(button,'nytc:cart-confirmed',{variantIds:intendedIds,verification:'cart'});
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          if (stage === 'verifying' && additionConfirmed) {
            feedback.textContent = 'Added, but the cart changed before it could be confirmed. View your cart before trying again.';
            track(button,'nytc:cart-failed',{variantIds:intendedIds,outcome:'uncertain'});
            return;
          }
          let recoveryFailed = false;
          for (const line of removed) {
            try {
              const item = {id:line.variant_id,quantity:1,properties:line.properties || {}};
              if (line.selling_plan_allocation) item.selling_plan = line.selling_plan_allocation.selling_plan.id;
              await post('cart/add.js', {items:[item]});
            } catch (_) { recoveryFailed = true; }
          }
          for (const line of created) {
            try { await removeOne(line); } catch (_) { recoveryFailed = true; }
          }
          feedback.textContent = recoveryFailed ? this.copy.changed : (error.message || this.copy.error);
          track(button,'nytc:cart-failed',{variantIds:intendedIds,outcome:recoveryFailed ? 'uncertain' : 'failed'});
        } finally {
          mutationBusy = false; this.busy = false; button.disabled = false; button.textContent = idle;
          repaint(); document.dispatchEvent(new CustomEvent('cart:build')); schedule();
        }
      }
      render(cart) {
        if (this.busy) return;
        if (this.sticky) {
          const isProPage = this.dataset.mode === 'product' && this.dataset.productHandle === pro;
          if (!isProPage && cart.items.some(i => Number(i.variant_id) === Number(this.sticky))) return;
          this.sticky = null; this.signature = null;
        }
        const cartHandles = cart.items.map(i => i.handle);
        const handles = this.dataset.mode === 'product' ? [this.dataset.productHandle] : cartHandles;
        let wanted = candidates(handles,cart,this.dataset.mode).filter(h => !cartHandles.includes(h));
        if (wanted.some(h => h.startsWith('__addon_'))) { this.renderLadder(cart, wanted); return; }
        const products = wanted.map(h => this.catalog.find(p => p.handle === h)).filter(Boolean).slice(0,2);
        const signature = JSON.stringify([products.map(p=>p.id), cart.items.some(i=>i.handle===pro)]);
        this.hidden = products.length === 0;
        if (signature === this.signature) return;
        this.signature = signature;
        const offers = this.querySelector('[data-offers]');
        offers.replaceChildren();
        this.querySelector('[data-included]').hidden = !(this.dataset.mode === 'product' && ['shilo','carter'].includes(this.dataset.productHandle));
        const proProduct = this.catalog.find(p => p.handle === pro);
        const jackProduct = this.catalog.find(p => p.handle === jack);
        const kitProduct = this.catalog.find(p => p.handle === bundle);
        const pumpLine = cart.items.find(i => i.handle === pro);
        products.forEach(product => {
          let variants = product.variants.filter(v=>v.available);
          if (!variants.length) return;
          if (singleChoice.includes(product.handle)) variants = variants.slice(0, 1);
          const isBundle = product.handle === bundle;
          const isHero = this.dataset.mode === 'product';
          const isUpgrade = isBundle && !!pumpLine;
          const row = document.createElement('div'); row.className = 'nytc-offer' + (isHero ? ' nytc-offer--hero' : '');
          const image = document.createElement('img'); image.src = sized(variantImage(product, variants[0]), isHero ? 240 : 160); image.alt = ''; image.loading = 'lazy'; image.width = isHero ? 84 : 56; image.height = isHero ? 100 : 66;
          const detail = document.createElement('div');
          const titleParts = product.title.split('|').map(t => t.trim());
          const link = document.createElement('a'); link.href = root + 'products/' + product.handle; link.textContent = isBundle ? this.copy.kit_title : titleParts[0];
          const sub = document.createElement('span'); sub.className = 'nytc-offer__sub'; sub.textContent = (isHero && !isBundle && titleParts[1]) ? titleParts[1] : '';
          const price = document.createElement(isHero ? 'div' : 'span'); if (isHero) price.className = 'nytc-price';
          const value = document.createElement('p'); value.className = 'nytc-offer__value';
          const badges = document.createElement('div'); badges.className = 'nytc-badges';
          const setPrice = variant => {
            if (!isHero) { price.textContent = money(variant.price); return; }
            price.replaceChildren();
            const now = document.createElement('span'); now.className = 'nytc-price__now'; now.textContent = money(variant.price); price.append(now);
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const was = document.createElement('s'); was.className = 'nytc-price__was'; was.textContent = money(variant.compare_at_price); price.append(was);
            }
          };
          const setBadges = variant => {
            if (!isHero) return;
            badges.replaceChildren();
            if ((product.tags || []).some(t => /^top selling$/i.test(t))) { const b = document.createElement('span'); b.className = 'nytc-badge nytc-badge--best'; b.textContent = this.copy.best_seller; badges.append(b); }
            if (variant.compare_at_price && variant.compare_at_price > variant.price) { const b = document.createElement('span'); b.className = 'nytc-badge nytc-badge--sale'; b.textContent = fill(this.copy.save_pct, {pct: Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}); badges.append(b); }
          };
          const setKitValue = variant => {
            if (!isBundle) return;
            value.replaceChildren();
            if (proProduct && jackProduct && this.copy.kit_value) {
              const proPrice = proProduct.variants[0].price;
              const jackPrice = jackProduct.variants[0].price;
              const extra = variant.price - proPrice;
              const saving = (proPrice + jackPrice) - variant.price;
              if (saving > 0) {
                const pill = document.createElement('span'); pill.className = 'nytc-badge nytc-badge--save'; pill.textContent = fill(this.copy.save_amt, {saving: money(saving)});
                const txt = document.createElement('span'); txt.textContent = this.copy.kit_value.replace('[extra]',money(extra)).replace('[saving]',money(saving));
                value.append(pill, txt);
              }
            }
          };
          setPrice(variants[0]); setBadges(variants[0]); setKitValue(variants[0]);
          const actions = document.createElement('div'); actions.className = 'nytc-offer__actions';
          let pick = null;
          const button = document.createElement('button'); button.type = 'button'; button.className = 'btn' + (isHero ? ' nytc-offer__cta' : '');
          const selected = () => pick ? pick.current : variants[0];
          const added = new Set();
          // deferred one tick: opening the drawer synchronously inside this click would let the same click bubble to Impulse's 'click outside closes the drawer' listener and shut it again
          const viewCart = () => { const l = document.querySelector('.js-drawer-open-cart'); if (l) setTimeout(() => l.click(), 0); else location.href = root + 'cart'; };
          const kitFor = v => kitProduct && v ? kitProduct.variants.find(k => k.available && String(k.title).trim().toLowerCase() === String(v.title).trim().toLowerCase()) : null;
          const mainInCart = () => { const v = selected(); if (!v) return false; const k = isHero ? kitFor(v) : null; return added.has(v.id) || !!(k && added.has(k.id)); };
          const mainLabel = () => {
            const v = selected();
            if (mainInCart()) return this.copy.in_cart;
            if (isHero) return v ? fill(this.copy.add_named, {name: product.title.split('|')[0].trim(), price: money(v.price)}) : this.copy.choose;
            return isUpgrade ? this.copy.upgrade : this.copy.add;
          };
          // bundle & save box (hero card only, Pro Pump context only)
          let bundleBox = null, bundleButton = null;
          const kitUpgrade = !!pumpLine;
          const showKitBox = isHero && kitProduct && proProduct && (this.dataset.productHandle === pro || kitUpgrade);
          const kitInCart = () => { const k = kitFor(selected()); return !!(k && added.has(k.id)); };
          const kitLabel = () => { const k = kitFor(selected()); if (k && added.has(k.id)) return this.copy.kit_in_cart; return fill(kitUpgrade ? this.copy.upgrade_kit : this.copy.get_kit, {price: k ? money(k.price) : ''}); };
          const paintButtons = () => { button.textContent = mainLabel(); button.classList.toggle('is-added', mainInCart()); if (bundleButton) { bundleButton.textContent = kitLabel(); bundleButton.classList.toggle('is-added', kitInCart()); } };
          const paintBundle = () => {
            if (!bundleBox) return;
            const v = selected(); const k = kitFor(v);
            const separate = proProduct.variants[0].price + (v ? v.price : 0);
            const saving = k ? separate - k.price : 0;
            if (!k || saving <= 0) { bundleBox.hidden = true; return; }
            bundleBox.hidden = false;
            bundleBox.querySelector('[data-save]').textContent = fill(this.copy.save_amt, {saving: money(saving)});
            bundleBox.querySelector('strong').textContent = this.copy.bundle_head;
            const line = bundleBox.querySelector('p'); line.replaceChildren();
            const parts = fill(this.copy.bundle_line, {kit: this.copy.kit_title, price: '{PRICE}', separate: money(separate)}).split('{PRICE}');
            const priceEl = document.createElement('b'); priceEl.textContent = money(k.price);
            line.append(parts[0] || '', priceEl, parts.slice(1).join('') || '');
            bundleButton.textContent = kitLabel(); bundleButton.classList.toggle('is-added', kitInCart());
          };
          const onPick = v => { setPrice(v); setBadges(v); setKitValue(v); image.src = sized(variantImage(product, v), isHero ? 240 : 160); button.disabled = false; paintBundle(); paintButtons(); };
          if (variants.length > 1) {
            const swatches = this.swatches || {};
            const allShades = variants.every(v => swatches[String(v.title || '').trim().toLowerCase()]);
            pick = allShades ? this.picker(product, variants, onPick) : this.dropdown(product, variants, onPick);
          }
          button.disabled = !!(pick && !pick.current);
          button.textContent = mainLabel();
          button.addEventListener('click', () => { const v = selected(); if (!v) return; if (mainInCart()) { viewCart(); return; } this.addToCart(button, mainLabel, v.id, {upgrade: isUpgrade, onAdded: id => { added.add(id); paintButtons(); }}); });
          actions.append(button);
          if (showKitBox) {
            bundleBox = document.createElement('div'); bundleBox.className = 'nytc-bundle'; bundleBox.hidden = true;
            const head = document.createElement('div'); head.className = 'nytc-bundle__head';
            const savePill = document.createElement('span'); savePill.className = 'nytc-badge nytc-badge--save'; savePill.setAttribute('data-save','');
            const headText = document.createElement('strong');
            head.append(savePill, headText);
            const line = document.createElement('p');
            bundleButton = document.createElement('button'); bundleButton.type = 'button'; bundleButton.className = 'btn btn--secondary';
            bundleButton.addEventListener('click', () => { const k = kitFor(selected()); if (!k) return; if (added.has(k.id)) { viewCart(); return; } this.addToCart(bundleButton, kitLabel, k.id, {upgrade: kitUpgrade, successText: kitUpgrade ? this.copy.replaced : this.copy.added, onAdded: id => { added.add(id); paintButtons(); }}); });
            bundleBox.append(head, line, bundleButton);
            paintBundle();
          }
          if (isHero) {
            detail.append(badges, link, sub, price);
            const full = document.createElement('div'); full.className = 'nytc-offer__full';
            if (pick) { const lbl = document.createElement('span'); lbl.className = 'nytc-offer__shades-label'; lbl.textContent = pick.inline ? this.copy.choose : this.copy.shade; full.append(lbl, pick.el); }
            full.append(actions); if (bundleBox) full.append(bundleBox);
            row.append(image, detail, full);
          } else {
            if (pick && pick.inline) { actions.prepend(pick.el); detail.append(link, price, value, actions); }
            else if (pick) detail.append(link, price, value, pick.el, actions);
            else detail.append(link, price, value, actions);
            row.append(image, detail);
          }
          offers.append(row);
        });
      }
    }
    customElements.define('nytc-contextual-upsells',ContextualUpsells);
    ['cart:updated','cart:build','cart:refresh','ajaxCart:updated','ajaxProduct:added'].forEach(name=>document.addEventListener(name,schedule));
    function observe() {
      const drawer=document.getElementById('CartDrawer');
      if(!drawer)return;
      new MutationObserver(schedule).observe(drawer,{attributes:true,attributeFilter:['class']});
      const items=drawer.querySelector('[data-products]');
      if(items)new MutationObserver(schedule).observe(items,{childList:true,subtree:true});
      let preview;
      function fitPreview(){
        const wrapper=document.getElementById('PBarNextFrameWrapper');
        document.documentElement.style.setProperty('--nytc-cart-preview-offset',(wrapper ? wrapper.getBoundingClientRect().height : 0)+'px');
        if(wrapper && wrapper!==preview){preview=wrapper;new ResizeObserver(fitPreview).observe(wrapper);}
      }
      fitPreview();
      window.addEventListener('resize',fitPreview);
      new MutationObserver(fitPreview).observe(document.body,{childList:true});
      schedule();
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe);else observe();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nytc-mobile-purchase"] && !Shopify.designMode) return;
  try {
    (()=>{
    if(customElements.get('nytc-mobile-purchase'))return;
    class MobilePurchase extends HTMLElement{
      connectedCallback(){
        this.form=document.getElementById(this.dataset.formId) || document.querySelector('.product-section form[action*="/cart/add"]');
        this.native=this.form?.querySelector('[data-add-to-cart]');
        this.section=this.form?.closest('.product-section');
        this.price=this.section?.querySelector('[data-product-price]');
        if(!this.native || !this.price)return;
        this.button=this.querySelector('button');
        this.onUpdate=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};
        this.onClick=()=>{
          if(this.choose){const picker=this.section.querySelector('.variant-input input:not([disabled]),.variant-wrapper select');(picker || this.native).scrollIntoView({behavior:'smooth',block:'center'});picker?.focus({preventScroll:true});}
          else if(!this.native.disabled){this.native.dataset.nytcSource='sticky';this.native.click();}
        };
        this.button.addEventListener('click',this.onClick);
        window.addEventListener('scroll',this.onUpdate,{passive:true});
        document.addEventListener('scroll',this.onUpdate,{passive:true,capture:true});
        window.addEventListener('resize',this.onUpdate);
        window.addEventListener('touchmove',this.onUpdate,{passive:true});
        this.section.addEventListener('change',this.onUpdate);
        /* Oct 21 2026 (Claude): also watch the real button directly, so the bar appears even where scroll events are swallowed. */
        if('IntersectionObserver' in window){this.io=new IntersectionObserver(this.onUpdate,{threshold:[0,.5,1]});this.io.observe(this.native);}
        this.observer=new MutationObserver(this.onUpdate);
        this.observer.observe(this.native,{attributes:true,childList:true,subtree:true});
        this.observer.observe(this.price,{childList:true,subtree:true});
        this.observer.observe(document.body,{childList:true});
        this.observer.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
        this.onUpdate();
      }
      update(){
        const rect=this.native.getBoundingClientRect();
        const open=document.documentElement.classList.contains('js-drawer-open') || document.querySelector('.modal--is-active,.drawer--is-open');
        const visible=rect.top>=0 && rect.bottom<=window.innerHeight-70;
        /* Oct 21 2026 (Claude): no screen-width gate any more -- the bar works on desktop too. */
        this.hidden=visible || !!open || !this.native.getClientRects().length;
        /* html class drives the chat-bubble hide + body padding (more reliable than :has on every phone). */
        const html=document.documentElement; if(html.classList.contains('nytc-float-on')===this.hidden){html.classList.toggle('nytc-float-on',!this.hidden);}
        if(this.hidden)return;
        const preview=document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect();
        this.style.setProperty('--nytc-preview-offset',preview && preview.top<window.innerHeight ? Math.max(0,window.innerHeight-preview.top)+'px' : '0px');
        this.querySelector('[data-mobile-price]').textContent=this.price.textContent.trim();
        const selected=this.section.querySelector('[data-product-select] option:checked');
        const hasOptions=this.dataset.hasOptions!=='true';
        this.querySelector('[data-mobile-option]').textContent=hasOptions && selected ? selected.textContent.split(' - ')[0].trim() : '';
        this.choose=hasOptions && rect.top>=window.innerHeight;
        /* NYTC FIX Sep 12 2026 (Claude): never overwrite the button label with an empty string --
           the native Add to Cart text goes blank for an instant during its loading animation. */
        const nextLabel=this.choose ? this.dataset.choose : this.native.textContent.trim();
        if(nextLabel){this.button.textContent=nextLabel;}
        this.button.disabled=!this.choose && (this.native.disabled || this.native.classList.contains('btn--loading'));
      }
      disconnectedCallback(){
        window.removeEventListener('scroll',this.onUpdate);document.removeEventListener('scroll',this.onUpdate,{capture:true});window.removeEventListener('resize',this.onUpdate);window.removeEventListener('touchmove',this.onUpdate);
        this.section?.removeEventListener('change',this.onUpdate);this.button?.removeEventListener('click',this.onClick);this.observer?.disconnect();this.io?.disconnect();cancelAnimationFrame(this.frame);document.documentElement.classList.remove('nytc-float-on');
      }
    }
    customElements.define('nytc-mobile-purchase',MobilePurchase);
  })();
  } catch(e) { console.error(e); }
})();

})();
